module.exports = __webpack_public_path__ + "img/part-3-info.7c4a9b46.png";